import { render } from "./StickyPricePanel.vue?vue&type=template&id=27f65122&scoped=true"
import script from "./StickyPricePanel.vue?vue&type=script&lang=js"
export * from "./StickyPricePanel.vue?vue&type=script&lang=js"

import "./StickyPricePanel.vue?vue&type=style&index=0&id=27f65122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f65122"]])

export default __exports__